import Vue from 'vue'
import LegacyComment from '~components/content/post-types/LegacyComment.vue'

Vue.component('LegacyComment', LegacyComment)
